import {
  SEARCH,
  ADVANCED_SEARCH,
} from './actions';

export const defaultState = {
  query: undefined,
  search: undefined,
};

export const onQueryChange = (state, { query }) => ({
  ...state,
  query,
});

export const onAdvancedSearch = (state, { criteria }) => ({
  ...state,
  search: criteria,
});

export default (state = defaultState, action) => {
  const reducer = {
    [SEARCH]: onQueryChange,
    [ADVANCED_SEARCH]: onAdvancedSearch,
  }[action.type];

  if (reducer) {
    return reducer(state, action);
  }

  return state;
};
